(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["looks"] && !Shopify.designMode) return;
  try {
    
(function () {
  var openPanel = null;
  var opener = null;

  function close() {
    if (!openPanel) return;
    openPanel.hidden = true;
    document.documentElement.classList.remove('looks-open');
    if (opener) opener.focus();
    openPanel = null;
  }

  function open(panel, button) {
    close();
    openPanel = panel;
    opener = button;
    panel.hidden = false;
    document.documentElement.classList.add('looks-open');
    panel.querySelector('.looks__close').focus();
  }

  // Match the chosen value of every option to a variant, then set the button from it.
  function updateBuy(buy) {
    var add = buy.querySelector('.js-lookAdd');
    var variants = JSON.parse(buy.querySelector('.js-lookVariants').textContent);
    var chosen = Array.prototype.map.call(buy.querySelectorAll('.js-lookOption'), function (option) {
      var checked = option.querySelector('.js-lookValue:checked');
      return checked ? checked.value : null;
    });
    var variant = chosen.indexOf(null) === -1 && variants.filter(function (v) {
      return v.options.every(function (value, i) { return value === chosen[i]; });
    })[0];

    buy.querySelectorAll('.js-lookValue').forEach(function (input) {
      input.closest('label').classList.toggle('active', input.checked);
    });
    add.dataset.variantId = variant && variant.available ? variant.id : '';
    add.disabled = !add.dataset.variantId;
    add.textContent = !variant ? add.dataset.selectText : variant.available ? add.dataset.addText : add.dataset.soldOutText;
    buy.querySelector('.looks__buy-error').textContent = '';
  }

  function addToCart(add) {
    var buy = add.closest('.js-lookBuy');
    var error = buy.querySelector('.looks__buy-error');
    var item = { id: add.dataset.variantId, quantity: 1 };
    // Same line property the product page adds for pre-order products.
    if (add.dataset.preOrder) item.properties = { '_Pre-order': 'Yes' };
    add.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          if (window.SLIDECART_UPDATE) window.SLIDECART_UPDATE();
          if (window.SLIDECART_OPEN) window.SLIDECART_OPEN();
        });
      })
      .catch(function (data) {
        error.textContent = (data && data.description) || add.dataset.errorText;
      })
      .then(function () {
        add.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.js-lookOpen');
    if (button) {
      var panel = document.getElementById('Look-' + button.dataset.look);
      if (panel) open(panel, button);
      return;
    }
    if (e.target.closest('.js-lookClose')) {
      close();
      return;
    }
    var add = e.target.closest('.js-lookAdd');
    if (add && add.dataset.variantId) addToCart(add);
  });

  document.addEventListener('change', function (e) {
    var buy = e.target.closest('.js-lookBuy');
    if (buy && e.target.matches('.js-lookValue')) updateBuy(buy);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    

window.onload = function() {
    let test = document.querySelector('.main-page__nav__item.active');
    var myElement = test;
    var myContainer = document.querySelector('.main-page__nav')
    var elementRect = myElement.getBoundingClientRect();
    var containerRect = myContainer.getBoundingClientRect();
    var scrollLeft = elementRect.left - containerRect.left + myContainer.scrollLeft;
    myContainer.scrollLeft = scrollLeft;
  };
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-collab"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ti"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-wf"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);
      const url = productRecommendationsSection.dataset.url;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product__recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
    const productRecommendationsSection = document.querySelector('.product__recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();
})();
